import {message} from "antd";
import {
  CLEAR_MANPOWER_PERFORMANCE_REPORT_DATA,
  CLEAR_MANPOWER_PERFORMANCE_SUCCESS,
  CREATE_MANPOWER_PERFORMANCE_SUCCESS,
  FETCH_MANPOWER_PERFORMANCE_REPORT_DATA_SUCCESS,
  FETCH_MANPOWER_PERFORMANCE_SUCCESS,
  GET_JOB_CARD_BY_LOCATION_SUCCESS,
  GET_JOB_CARD_STATUS_BY_ACTIVITY_ID,
  GET_MANPOWER_PERFORMANCE_SUCCESS,
  SAVE_MANPOWER_PERFORMANCE_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
  jobCard: [],
  disableMaintenanceListByJobCard: {},
  reports: []
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_MANPOWER_PERFORMANCE_QUERY: {
      return {
        ...state,
        query: action.query
      };
    }

    case GET_MANPOWER_PERFORMANCE_SUCCESS: {
      const query = { ...state.query };
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total
      };
    }

    case CREATE_MANPOWER_PERFORMANCE_SUCCESS: {
      return {
        ...state,
        resource: action.data
      };
    }

    case FETCH_MANPOWER_PERFORMANCE_SUCCESS: {
      return {
        ...state,
        edit: action.data
      };
    }

    case CLEAR_MANPOWER_PERFORMANCE_SUCCESS: {
      return {
        ...state,
        jobCard: [],
        edit: {}
      };
    }

    case GET_JOB_CARD_BY_LOCATION_SUCCESS: {
      return {
        ...state,
        jobCard: action.data
      };
    }

    case GET_JOB_CARD_STATUS_BY_ACTIVITY_ID: {
      return {
        ...state,
        disableMaintenanceListByJobCard: action.data
      };
    }

    case FETCH_MANPOWER_PERFORMANCE_REPORT_DATA_SUCCESS: {
      if (action.data.length === 0) {
        message.error(
          "No data found for given query, please try with different parameters!"
        );
      }
      return {
        ...state,
        reports: action.data
      };
    }

    case CLEAR_MANPOWER_PERFORMANCE_REPORT_DATA: {
      return {
        ...state,
        reports: []
      };
    }

    default:
      return state;
  }
};
